
const img_icon = {
default: <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1156.000000pt" height="1024.000000pt" viewBox="0 0 1156.000000 1024.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M1230 9581 c-320 -68 -564 -297 -667 -627 l-28 -89 0 -3490 c0 -3381
1 -3492 19 -3559 93 -344 350 -591 688 -660 70 -14 508 -16 4576 -16 3100 0
4517 3 4558 11 359 63 642 338 715 693 18 88 19 209 19 3526 0 3315 -1 3438
-19 3525 -35 171 -114 319 -236 441 -113 114 -232 185 -397 236 l-73 23 -4535
2 c-4333 2 -4539 1 -4620 -16z m9042 -691 c45 -13 93 -51 116 -94 16 -29 17
-239 17 -3426 0 -3187 -1 -3397 -17 -3426 -24 -43 -71 -81 -117 -94 -26 -7
-1452 -9 -4472 -8 -4200 3 -4436 4 -4466 20 -18 10 -45 35 -60 55 l-28 36 -3
3405 c-2 3141 -1 3406 14 3438 20 42 72 84 117 94 51 13 8855 12 8899 0z"/>
<path d="M2817 8175 c-220 -42 -393 -132 -555 -289 -331 -320 -414 -807 -208
-1221 197 -395 589 -616 1036 -583 176 13 338 69 491 169 548 360 637 1131
185 1607 -138 145 -312 249 -501 298 -127 33 -329 41 -448 19z"/>
<path d="M5995 5900 l-1410 -1410 -440 440 -440 440 -883 -883 -882 -882 0
-528 0 -527 3880 0 3880 0 0 1233 0 1232 -1148 1148 -1147 1147 -1410 -1410z"/>
</g>
</svg>
}

export default img_icon;
